var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6C11.0418 6.0016 9.64389 6.54018 8.61282 7.49761C7.58174 8.45504 7.00173 9.75313 7.00001 11.1071C6.99826 12.2136 7.3875 13.2901 8.108 14.1714C8.108 14.1714 8.258 14.3548 8.2825 14.3813L12.5 19L16.7195 14.379C16.7415 14.3544 16.892 14.1714 16.892 14.1714L16.8925 14.17C17.6126 13.2891 18.0017 12.2131 18 11.1071C17.9983 9.75313 17.4183 8.45504 16.3872 7.49761C15.3561 6.54018 13.9582 6.0016 12.5 6ZM12.5 12.9643C12.1044 12.9643 11.7178 12.8554 11.3889 12.6513C11.06 12.4472 10.8036 12.1572 10.6522 11.8178C10.5009 11.4785 10.4613 11.1051 10.5384 10.7448C10.6156 10.3846 10.8061 10.0537 11.0858 9.79394C11.3655 9.53422 11.7219 9.35734 12.1098 9.28568C12.4978 9.21403 12.8999 9.2508 13.2654 9.39137C13.6308 9.53193 13.9432 9.76996 14.1629 10.0754C14.3827 10.3808 14.5 10.7398 14.5 11.1071C14.4993 11.5995 14.2884 12.0715 13.9135 12.4197C13.5386 12.7678 13.0302 12.9637 12.5 12.9643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilledIcon);
export default __webpack_public_path__ + "static/media/location-filled-icon.69d8705048102b4787de49acc5aaabe2.svg";
export { ForwardRef as ReactComponent };